<template>
    <div class="plus_home_div">
        <PlusHome></PlusHome>
    </div>
</template>

<script type="text/javascript">

import PlusHome from '@/components/plus_page/plus_home.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        PlusHome,
    },
    methods: {
        ...mapActions({
        })
    },

    mounted: function () {
    }
}
</script>
<style type="text/css">
</style>
